const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20drama%20poster%20featuring%20warm%20romantic%20atmosphere%20with%20soft%20golden%20and%20rose%20tones%2C%20elegant%20silhouette%20composition%2C%20modern%20Chinese%20drama%20aesthetic%2C%20clean%20background%20with%20subtle%20floral%20elements%2C%20premium%20editorial%20style%2C%20soft%20lighting&width=600&height=800&seq=drama-card-01&orientation=portrait',
    title: '玫瑰的故事',
    tag: '都市情感',
    desc: '刘亦菲主演都市情感大剧，讲述黄亦玫跨越二十余年的成长与情感历程。',
    rating: '9.8',
    status: '全38集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20mystery%20detective%20drama%20poster%20with%20ancient%20Chinese%20Tang%20dynasty%20aesthetic%2C%20dark%20moody%20atmosphere%20with%20crimson%20and%20gold%20accents%2C%20mysterious%20silhouettes%2C%20traditional%20elements%2C%20cinematic%20composition%2C%20dramatic%20lighting&width=600&height=800&seq=drama-card-02&orientation=portrait',
    title: '唐朝诡事录之西行',
    tag: '古装悬疑',
    desc: '卢凌风与苏无名西行探案，揭秘大唐西域诡谲奇案。',
    rating: '9.6',
    status: '更新中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20fantasy%20romance%20drama%20poster%20with%20ethereal%20dreamy%20atmosphere%2C%20soft%20peach%20and%20lavender%20tones%2C%20floating%20elements%2C%20elegant%20silhouettes%2C%20ancient%20Chinese%20fantasy%20aesthetic%2C%20magical%20glowing%20particles%2C%20clean%20artistic%20composition&width=600&height=800&seq=drama-card-03&orientation=portrait',
    title: '长相思 第二季',
    tag: '古装仙侠',
    desc: '杨紫主演仙侠巨制，上古情缘再续，命运纠葛全面升级。',
    rating: '9.5',
    status: '全集上线',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20romance%20drama%20poster%20with%20bright%20uplifting%20atmosphere%2C%20warm%20sunlight%20tones%2C%20contemporary%20urban%20setting%2C%20two%20silhouettes%2C%20clean%20minimalist%20composition%2C%20soft%20bokeh%20background%2C%20fresh%20youthful%20aesthetic&width=600&height=800&seq=drama-card-04&orientation=portrait',
    title: '你比星光美丽',
    tag: '都市爱情',
    desc: '谭松韵与许凯甜蜜搭档，科技创业背景下的都市爱情故事。',
    rating: '9.3',
    status: '更新至32集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20drama%20poster%20with%20sophisticated%20legal%20office%20atmosphere%2C%20cool%20professional%20tones%20with%20warm%20accents%2C%20modern%20Seoul%20aesthetic%2C%20two%20professional%20silhouettes%2C%20clean%20composition%2C%20dramatic%20contrast%20lighting&width=600&height=800&seq=drama-card-05&orientation=portrait',
    title: '好搭档',
    tag: '韩剧律政',
    desc: '张娜拉与南志铉联手，明星离婚律师的职场与人生故事。',
    rating: '9.1',
    status: '更新至6集',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          精选剧集
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          编辑精选，不容错过的品质好剧
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cards.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer hover:bg-white transition-colors duration-200"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden rounded-t-xl">
                <img
                  src={item.image}
                  alt={`${item.title} - 电视剧海报`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <span className="absolute top-3 left-3 bg-accent-500 text-white text-xs px-2.5 py-1 rounded-full font-medium">
                  {item.rating}
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.status}</span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}